import styled from "styled-components/native";
import { View } from "react-native";
import { Theme } from "../../../../theming/types";

type PositionsGridProps = {
  isLeg?: boolean;
  isSpecialWager?: boolean;
  theme: Theme;
};

export const PositionsGrid = styled(View)<{
  isLeg?: boolean;
  isSpecialWager?: boolean;
}>`
  display: grid;
  grid-template-columns: ${({ isLeg, isSpecialWager }: PositionsGridProps) =>
      isLeg && !isSpecialWager ? "58px" : "25px"} auto;
  column-gap: ${({ theme }: { theme: Theme }) => theme.space["space-3"]};
  row-gap: ${({ theme }: { theme: Theme }) => theme.space["space-4"]};
`;

export const Content = styled(View)`
  width: 65px;
  justify-content: center;
`;
